import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import AppUtils from '../../../utils/AppUtils'
import AppConstants from '../../../utils/AppConstants'
import ProductForm from '../../../components/forms/ProductForm'
import Popup from '../../../components/elements/Popup'

import Types from '../../../actions/Types'
import GetAction from '../../../actions/products/GetBasicAction'
import PutAction from '../../../actions/products/PutFullAction'
import ListOwnersAction from '../../../actions/owners/ListAction'
import ListDiametersAction from '../../../actions/diameters/ListAction'
import ListBatteriesAction from '../../../actions/batteries/ListAction'
import ClearErrorAction from '../../../actions/app/ClearErrorAction'

class UpdateProductFullPopup extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      submit: null
    }

    // Bind events
    this.submit = this.submit.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  componentDidMount() {
    this.props.get(this.props.id)
    this.props.fetchOwners()
    this.props.fetchDiameters()
    this.props.fetchBatteries()
  }

  componentDidUpdate(prevProps, prevState) {
    // If fetch is error, close with error
    if (
      prevProps.isLoading
      &&
      !this.props.isLoading
      &&
      this.props.loadError
    ) {
      AppUtils.setStatus(AppConstants.STATUS.TYPE.FAILURE, "Impossible d'obtenir les infos sur ce matériel.")
      this.props.onClose(false)
    }

    // When successful, close popup
    if (
      prevProps.isSaving
      &&
      !this.props.isSaving
      &&
      !this.props.error
    ) {
      AppUtils.setStatus(AppConstants.STATUS.TYPE.SUCCESS, 'Matériel modifié.')
      this.props.onClose(true)
    }
  }

  submit() {
    if (_.isFunction(this.state.submit)) {
      this.state.submit()
    }
  }

  onSubmit(data) {
    this.props.put(this.props.id, data)
  }

  render() {
    return (
      <Popup
        header='Modifier le matériel'
        body={
          <ProductForm
            isFull={true}
            category={this.props.data && this.props.data.category}
            data={this.props.data}
            onSubmit={this.onSubmit}
            onClearError={this.props.clearError}
            isLoading={this.props.isLoading}
            isSaving={this.props.isSaving}
            registerSubmit={(submit) => { this.setState({ submit })}}
            error={this.props.saveError}
            ownersList={this.props.ownersList}
            ownersIsFetching={this.props.ownersIsFetching}
            diametersList={this.props.diametersList}
            diametersIsFetching={this.props.diametersIsFetching}
            batteriesList={this.props.batteriesList}
            batteriesIsFetching={this.props.batteriesIsFetching}
          />
        }
        footer={[
          {
            type: Popup.BUTTONTYPE.CLOSE,
            title: 'Annuler',
            color: 'red',
            icon: 'close',
            basic: true,
            onClick: () => this.props.onClose(false)
          },
          {
            type: Popup.BUTTONTYPE.SUBMIT,
            title: 'Modifier',
            color: 'orange',
            icon: 'checkmark',
            onClick: this.submit
          }
        ]}
        isLoading={this.props.isLoading}
        isSaving={this.props.isSaving}
      />
    )
  }
}

UpdateProductFullPopup.propTypes = {
  // Properties
  id: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,

  // Redux State
  data: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  loadError: PropTypes.object,
  isSaving: PropTypes.bool.isRequired,
  saveError: PropTypes.object,
  ownersList: PropTypes.array,
  ownersIsFetching: PropTypes.bool.isRequired,
  diametersList: PropTypes.array,
  diametersIsFetching: PropTypes.bool.isRequired,
  batteriesList: PropTypes.array,
  batteriesIsFetching: PropTypes.bool.isRequired,

  // Redux Actions
  get: PropTypes.func.isRequired,
  put: PropTypes.func.isRequired,
  fetchOwners: PropTypes.func.isRequired,
  fetchDiameters: PropTypes.func.isRequired,
  fetchBatteries: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    data: state.entities.products.get.basic.data,
    isLoading: state.entities.products.get.basic.isFetching,
    loadError: state.entities.products.get.basic.error,
    isSaving: state.entities.products.put.full.isFetching,
    saveError: state.entities.products.put.full.error,
    ownersList: state.entities.owners.list.data,
    ownersIsFetching: state.entities.owners.list.isFetching,
    diametersList: state.entities.diameters.list.data,
    diametersIsFetching: state.entities.diameters.list.isFetching,
    batteriesList: state.entities.batteries.list.data,
    batteriesIsFetching: state.entities.batteries.list.isFetching
  }),
  (dispatch) => ({
    get: (id) => (dispatch(GetAction({ id }))),
    put: (id, data) => (dispatch(PutAction({ id, data }))),
    fetchOwners: () => (dispatch(ListOwnersAction({}))),
    fetchDiameters: () => (dispatch(ListDiametersAction({}))),
    fetchBatteries: () => (dispatch(ListBatteriesAction({}))),
    clearError: () => (dispatch(ClearErrorAction(Types.PRODUCTS.PUT)))
  })
)(UpdateProductFullPopup)



// WEBPACK FOOTER //
// ./src/containers/popups/products/UpdateProductFullPopup.js